import apiAnalytics from '@services/api/manager/machines/analytics'

/**
 * @param {object} payload An object with payload parameters.
 * @returns {object} An object with only query parameters.
 */
function query(payload) {
  const query = Object.assign({}, payload)
  delete query.machine_id
  return query
}

export default {
  namespaced: true,
  actions: {
    getPanelMachine(_, payload) {
      return apiAnalytics.panelMachine(this.$http, payload, query(payload))
    },

    getPanelBatteries(_, payload) {
      return apiAnalytics.panelBatteries(this.$http, payload, query(payload))
    },

    getPanelTemperatures(_, payload) {
      return apiAnalytics.panelTemperatures(this.$http, payload, query(payload))
    },

    getPanelOperatingHours(_, payload) {
      return apiAnalytics.panelOperatingHours(this.$http, payload, query(payload))
    },

    getPanelTilt(_, payload) {
      return apiAnalytics.panelTilt(this.$http, payload, query(payload))
    },

    getPanelMotorsPercentage(_, payload) {
      return apiAnalytics.panelMotorsPercentage(this.$http, payload, query(payload))
    },

    getPanelMotorsVoltage(_, payload) {
      return apiAnalytics.panelMotorsVoltage(this.$http, payload, query(payload))
    },

    getPanelMotorsCurrent(_, payload) {
      return apiAnalytics.panelMotorsCurrent(this.$http, payload, query(payload))
    },

    getPanelMap(_, payload) {
      return apiAnalytics.panelMap(this.$http, payload, query(payload))
    },
  },
}
